import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Komponenter
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import ViTilbyder from './pages/ViTilbyder';
import ServiceDetail from './pages/ServiceDetail';
import FaaEtTilbud from './pages/FaaEtTilbud';
import Anmeldelser from './pages/Anmeldelser';
import GalleryPage from './pages/GalleryPage';
import Nyheder from './pages/Nyheder';
import Profil from './pages/Profil';
import Kontakt from './pages/Kontakt';
import Error404 from './pages/Error404';
import Error403 from './pages/Error403';

function App() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-brand-light text-brand-dark antialiased">
        {/* Header */}
        <Header />

        {/* Hovedindhold */}
        <main className={`flex-grow ${isHome ? '' : 'pt-[100px] min-[1150px]:pt-[112px]'}`}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/vi-tilbyder" element={<ViTilbyder />} />
            <Route path="/vi-tilbyder/:slug" element={<ServiceDetail />} />
            <Route path="/faa-et-tilbud" element={<FaaEtTilbud />} />
            <Route path="/anmeldelser" element={<Anmeldelser />} />
            
            {/* Galleri-ruter (både oversigt og detalje) */}
            <Route path="/referencegalleri" element={<GalleryPage />} />
            <Route path="/referencegalleri/:slug" element={<GalleryPage />} />
            
            <Route path="/nyheder" element={<Nyheder />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="/kontakt" element={<Kontakt />} />
            
            {/* Fejlsider */}
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
